import { AgenciesApi } from "@socotec.io/user-management-sdk";
import { userManagementConfig, fetchAll } from "@/setup/openApiConfig";

const agenciesApi = new AgenciesApi(userManagementConfig);

export const AgencyClient = {
  listAll: async (filters = {}) => {
    return await fetchAll(agenciesApi, "list", filters, Infinity);
  },
  list: async (filters = {}) => {
    return await fetchAll(agenciesApi, "list", filters, Infinity);
  },

  retrieve: async ({ uuid }) => {
    return await agenciesApi.retrieve({ uuid });
  },

  retrieveByUserUuid: async ({ uuid }) => {
    return await agenciesApi.retrieveUserAgency({ userUuid: uuid });
  },

  retrieveByCode: async ({ code }) => {
    return await agenciesApi.retrieveByCode({ code });
  },
};
